import React, { useContext, useMemo } from 'react'
import { _matchDisplayTypes } from '../elements/matches/MatchContent';
import { matchFilterHelpers } from '../elements/matches/MatchFilters';
import { CreatePlayoffContext } from '../create/CreatePlayoff';

export const useMatchDisplayType = ({
  match_true,
  results_matchDay,
  matchUrl,
  matchDisplayType }) => {

  // createPlayoffContext
  const createPlayoffContext = useContext(CreatePlayoffContext);
  const { createPlayoff_state } = createPlayoffContext ?? {};

  let showScores;
  const { _itemKey, _status, _results, isPlayoff, _results_matchDay, _results_realtime } = match_true ?? {}

  let _results_combined = _results ? _.cloneDeep(_results) : {}

  function combineResults(r, rmd, rrt) {

    const hasScore = !_.isEmpty(r?.score);
    const hasScores = !_.isEmpty(r?.scores);

    let result;

    if (!hasScore && !hasScores) {
      if (rrt) {
        result = _.merge({}, r, rrt);
        result._resultsFrom = "realtime";
      }
      if (rmd) {
        result = _.merge({}, r, rmd);
        result._resultsFrom = "matchDay";
      }
    } else {
      result = _.cloneDeep(r);
    }

    return result;
  }

  if (_results_matchDay || _results_realtime) {
    _results_combined = combineResults(_results, _results_matchDay, _results_realtime)
  }

  const { isMissing, isBye, isPending, isPendingish, isPendingAway } = _status ?? {}
  const { matchCn, complete, winner } = _results_combined ?? {}

  const hasScore = !_.isEmpty(_results_combined?.score)
  const hasScores = !_.isEmpty(_results_combined?.scores)
  const hasTrueScore = hasScores || hasScore

  const { _isPending, _isPendingA } = useMemo(() => {
    const _matchPlayoffPendings = matchFilterHelpers.matchesWithPendings(createPlayoff_state?.playoff_matchInfo?.matches)
    const pendingMatch = _matchPlayoffPendings?.[match_true?._itemKey]
    const _isPending = pendingMatch && !pendingMatch.home ? true : false
    const _isPendingA = pendingMatch && pendingMatch.home ? true : false
    return { _isPending, _isPendingA }
  }, [match_true])

  const mpt = useMemo(() => {
    let _matchPropType = matchDisplayType

    if (!complete && !_matchPropType?.includes('grid')) {
      switch (matchDisplayType) {
        case _matchDisplayTypes.teamMatches:
          _matchPropType = _matchDisplayTypes.teamMatchesNoScore
          break;
        default:
          if (isPending) {
            _matchPropType = _matchDisplayTypes.playoffMatchPending
          } else if (isPendingAway) {
            _matchPropType = _matchDisplayTypes.playoffMatchAwayPending
          } else {
            if (!results_matchDay) {
              _matchPropType = _matchDisplayTypes.levelMatchNoScore
            }
          }
      }
    }

    if (isPlayoff) {
      switch (_matchPropType) {
        case _matchDisplayTypes.levelMatchNoScore:
        case _matchDisplayTypes.levelMatches:
        case _matchDisplayTypes.teamMatches:
        case _matchDisplayTypes.teamMatchesNoScore:
        case _matchDisplayTypes.scoreboard:
          _matchPropType = _matchPropType + '_playoffs';
          break;
      }
    }

    if (_matchPropType === 'levelMatches' && matchUrl) {
      _matchPropType = _matchPropType + '_vid'
    }

    switch (matchDisplayType) {
      case _matchDisplayTypes.playoff_grid:
        showScores = false
        if (!hasScores && !hasScore) {
          if (_isPending) {
            _matchPropType = _matchDisplayTypes.playoff_grid_pending
          } else if (_isPendingA) {
            _matchPropType = _matchDisplayTypes.playoff_grid_pendingA
          } else if (isPending) {
            _matchPropType = _matchDisplayTypes.playoff_grid_noScore_pending
          } else if (isPendingAway) {
            _matchPropType = _matchDisplayTypes.playoff_grid_noScore_pendingA
          } else {
            _matchPropType = _matchDisplayTypes.playoff_grid_noScore
          }
        }
        break;
      case _matchDisplayTypes.levelOverviewMatches:
        // showScores = false
        break;
      default:
      // showScores = hasScores || results_realtime || results_matchDay
    }
    return _matchPropType
  }, [_itemKey])


  return (
    { mpt }
  )
}
